var map = {
	"./p015.png": 78,
	"./p042_words.txt": 79,
	"./p054_poker.txt": 80,
	"./p059_cipher.txt": 81,
	"./p067_triangle.txt": 82,
	"./p068_1.png": 83,
	"./p068_2.png": 84,
	"./p079_keylog.txt": 85,
	"./p081_matrix.txt": 86,
	"./p084.png": 87,
	"./p085.png": 88,
	"./p086.png": 89,
	"./p11_data.txt": 90,
	"./p13_data.txt": 91,
	"./p18_triangle.txt": 92,
	"./p22_names.txt": 93,
	"./p8_data.txt": 94
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77;